import { appBarMeta } from "@constants/appbar";
import { CMEContainer } from "@features/cme/containers/CMEContainer";
import { AppBar } from "@features/dashboard/layouts/AppBar";
import DocumentTitle from "components/DocumentTitle";
import { router } from "expo-router";
import { useTranslation } from "react-i18next";
import { Appbar } from "react-native-paper";

const CMERoute = () => {
	const { t } = useTranslation();

	return (
		<>
			<DocumentTitle title={appBarMeta.cme.title} />
			<AppBar
				title={appBarMeta.cme.title}
				renderRight={() => (
					<Appbar.Action
						icon="information-outline"
						accessibilityLabel={t("cme.viewDisclaimer")}
						onPress={() => router.push("/cme/disclaimer")}
					/>
				)}
			/>
			<CMEContainer />
		</>
	);
};

export default CMERoute;
